import { render, staticRenderFns } from "./ViewSingleOffer.vue?vue&type=template&id=e9ddfb46&scoped=true&"
import script from "./ViewSingleOffer.vue?vue&type=script&lang=js&"
export * from "./ViewSingleOffer.vue?vue&type=script&lang=js&"
import style0 from "./ViewSingleOffer.vue?vue&type=style&index=0&id=e9ddfb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ddfb46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VFlex,VImg,VLayout})
